import { Link } from "react-router-dom";
import { PillButton } from "../components/ui-kit";
import { motion } from "framer-motion";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="min-h-screen flex items-center justify-center relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 w-[500px] h-[500px] accent-glow rounded-full -translate-x-1/2 -translate-y-1/2" />
      <div className="text-center px-6 relative">
        <motion.h1 initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8 }}
          className="text-[8rem] md:text-[14rem] font-heading font-black leading-none tracking-tighter text-accent">404</motion.h1>
        <h2 className="text-2xl md:text-3xl font-black uppercase tracking-tight mb-4">This rep doesn't exist.</h2>
        <p className="text-muted-foreground mb-8 max-w-md mx-auto">The page you're looking for wandered off to the gym. Let's get you back on track.</p>
        <PillButton to="/" testid="notfound-home-btn">Back to Home</PillButton>
      </div>
    </div>
  );
}
